import { EArmType } from "./Waypoint";
import { EHotelType } from "./Module";
import {
  Binning,
  Gain,
  Exposure,
  Brightness,
  EColorFormat,
} from "./ImagerCapabilities";

export enum EBarcodeScannerType {
  HoneywellN431XScanner = 1,
  PsrCamera = 2,
}

export enum ECarrierAutoCalibrationType {
  ProximitySensor = 1,
  PsrCamera = 2,
}

export interface BarcodeScannerCapabilities {
  barcodeScannerType: EBarcodeScannerType;
  psrCameraId: number;
}

export interface CarrierAutoCalibrationCapabilities {
  carrierAutoCalibrationType: ECarrierAutoCalibrationType;
  psrCameraId: number;
}

export interface PsrCameraCapabilities {
  psrCameraId: number;
  focus: Focus;
  binning: Binning;
  gain: Gain;
  exposure: Exposure;
  brightness: Brightness;
  colorFormat: EColorFormat;
}

export interface Focus {
  minFocus: number;
  maxFocus: number;
}

export interface PsrCapabilities {
  barcodeScanner: BarcodeScannerCapabilities;
  carrierAutoCalibration?: CarrierAutoCalibrationCapabilities;
  psrCameras?: PsrCameraCapabilities[];
  supportedArmTypes: EArmType[];
  hotelTypes: EHotelType[];
}
